import React from "react";
import "./NotificationList.scss";

const NotificationItem = ({
  notification,
  isExpanded,
  onToggleExpand,
  onMarkAsRead,
  onDelete,
  onNavigate,
  typeInfo,
  isPreview,
}) => {
  const formatTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return "just now";
    if (diffInSeconds < 3600) return Math.floor(diffInSeconds / 60) + "m ago";
    if (diffInSeconds < 86400) return Math.floor(diffInSeconds / 3600) + "h ago";
    if (diffInSeconds < 604800) return Math.floor(diffInSeconds / 86400) + "d ago";

    return date.toLocaleDateString();
  };

  const truncateMessage = (message, length = 80) => {
    return message && message.length > length ? message.substring(0, length) + "..." : message;
  };

  const getAvatarColor = () => {
    const colors = {
      primary: "#0d6efd",
      info: "#0dcaf0",
      success: "#198754",
      warning: "#ffc107",
      danger: "#dc3545",
      secondary: "#6c757d",
    };
    return colors[typeInfo?.color] || colors.primary;
  };

  return (
    <div
      className={!notification.isRead ? "notification-item unread" : "notification-item read"}
      onClick={() => {
        if (!notification.isRead && onMarkAsRead) {
          onMarkAsRead(null, notification.id);
        }
        onToggleExpand();
      }}
    >
      {/* Avatar */}
      <div className="notification-avatar">
        <div style={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          background: getAvatarColor(),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.3rem",
          color: "white",
          fontWeight: "600",
        }}>
          {notification.title?.charAt(0).toUpperCase() || "N"}
        </div>
        <div className={"notification-avatar-icon " + (typeInfo?.color || "primary")}>
          <i className={notification.iconClass || "ri-notification-line"}></i>
        </div>
      </div>

      {/* Body */}
      <div className="notification-body">
        <div className="notification-header">
          <p className="notification-sender">{notification.title}</p>
          <span className="notification-time">{formatTime(notification.createdAt)}</span>
        </div>
        
        {notification.relatedEntityType && (
          <p className="notification-action">
            {notification.relatedEntityType}
          </p>
        )}
        
        <p className="notification-message">
          {isExpanded ? notification.message : truncateMessage(notification.message)}
        </p>

        {isExpanded && !isPreview && (
          <div className="notification-buttons">
            {!notification.isRead && (
              <button className="btn-secondary" onClick={(e) => { e.stopPropagation(); onMarkAsRead(e, notification.id); }}>
                Mark as read
              </button>
            )}
            <button className="btn-secondary" style={{ color: '#dc3545' }} onClick={(e) => { e.stopPropagation(); onDelete(e, notification.id); }}>
              Delete
            </button>
          </div>
        )}
      </div>

      {/* Status Dot */}
      <div className={!notification.isRead ? "notification-status-dot unread" : "notification-status-dot read"}></div>
    </div>
  );
};

export default NotificationItem;
